export enum PartnerAllowedIntegrationSteps {
  SelectIntegrationCompany = 1,
  SelectIntegrationType = 2,
  ShowRequirements = 3,
  AddIntegration = 4,
  SuccessView = 5,
  EditIntegration = 6,
  ShowRequirementsOnEdit = 7,
}
